<script>
    import CRUD from './CRUD.svelte';
    import {
        fetchActivos,
        saveActivo,
        removeActivo,
        searchActivos,
        subscribeToActivos,
        unsubscribeFromActivos,
        getTiposForDropdown,
        fetchAtributosActivo,
        importActivosFromCSV
    } from '../controllers/activoController.js';
    import { onMount } from 'svelte';
    import { t } from 'svelte-i18n';

    let activoColumns = [
        { label: $t('fields.code'), field: 'codigo', type: 'text' },
        { label: $t('fields.name'), field: 'nombre', type: 'text' },
        { label: $t('fields.description'), field: 'descrip', type: 'text' },
        { label: $t('fields.type'), field: 'tipo', type: 'relation', relationField: 'descrip' },
        { label: $t('fields.price'), field: 'precio', type: 'number' },
        { label: $t('fields.image'), field: 'firstImage', type: 'gallery_image' },
        { label: $t('fields.state'), field: 'sta', type: 'bool' },
    ];

    let newActivo = {
        codigo: '',
        descrip: '',
        tipo: '',
        precio: 0,
        sta: true,
        atributos: [], // Atributos adicionales
    };

    let editColumns = [
        { label: $t('fields.code'), key: 'codigo', type: 'text', required: true },
        { label: $t('fields.name'), key: 'nombre', type: 'text', required: true },
        { label: $t('fields.description'), key: 'descrip', type: 'text', required: true },
        { label: $t('fields.type'), key: 'tipo', type: 'select', required: false, options: [] },
        { label: $t('fields.price'), key: 'precio', type: 'number', required: false },
        { label: $t('fields.state'), key: 'sta', type: 'checkbox' },
    ];

    onMount(async () => {
        console.log("Componente de Activos montado");
        // Cargar tipos para el dropdown
        try {
            const tiposOptions = await getTiposForDropdown();
            editColumns = editColumns.map(col => {
                if (col.key === 'tipo') {
                    return { ...col, options: tiposOptions };
                }
                return col;
            });
        } catch (error) {
            console.error("Error loading tipos:", error);
        }
    });
</script>

<CRUD 
    title={$t('entities.activos')}
    entityName="activo"
    newEntity={newActivo}
    columns={activoColumns}
    fetchEntities={fetchActivos}
    saveEntity={saveActivo}
    removeEntity={removeActivo}
    searchEntities={searchActivos}
    subscribeToChanges={subscribeToActivos}
    unsubscribeFromChanges={unsubscribeFromActivos}
    editColumns={editColumns}
    fetchAtributos={fetchAtributosActivo}
    importActivosFromCSV={importActivosFromCSV}
    enableGallery={true}
    galleryConfig={{ collection: 'activo_gallery', relationField: 'activo', urlField: 'url', fileField: 'url', tabLabel: $t('gallery.gallery') }}
/>
